export default __webpack_public_path__ + "static/media/panoramic.12cfb85a.png";